import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Tooltip } from '@material-ui/core'

import './tooltip.component.css'

const styles = {}

/**
 * NavTooltip Component
 */
class NavTooltip extends Component {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { title, isNew, openInNewTab, children, placement, arrow } = this.props
    const isBottom = placement === 'bottom'
    const popperClassName = [
      'nav-tooltip',
      isBottom ? 'nav-tooltip--popper-bottom' : '',
      arrow ? '' : 'nav-tooltip--no-arrow'
    ].filter(Boolean).join(' ')

    return (
      <Tooltip
        classes={{
          popper: popperClassName,
          tooltip: `nav-tooltip_item ${isNew ? 'nav-tooltip_item--new' : ''}`
        }}
        title={openInNewTab ? `${title} - OPENS IN NEW TAB` : title}
        placement={placement}
        arrow={arrow}
      >
        {children}
      </Tooltip>
    )
  };
}

NavTooltip.propTypes = {
  title: PropTypes.node,
  isNew: PropTypes.bool,
  openInNewTab: PropTypes.bool,
  children: PropTypes.node,
  placement: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
  arrow: PropTypes.bool
}

NavTooltip.defaultProps = {
  placement: 'right',
  arrow: true
}

export default withStyles(styles)(NavTooltip)
